<template>
  <v-img :src="$functions.parseBase64ToImage(image)" :width="width" />
</template>

<script>
export default {
  name: "ImageBase64",

  props: {
    image: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "200"
    }
  }
};
</script>